var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcTaskBug(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M14.25 11.25V8.9535C14.25 8.17031 13.9389 7.41919 13.3852 6.86533C12.8315 6.31146 12.0804 6.0002 11.2972 6H6.702C5.91894 6.0004 5.16809 6.31174 4.61453 6.86559C4.06097 7.41944 3.75 8.17044 3.75 8.9535V11.25C3.75 11.9394 3.8858 12.6221 4.14963 13.2591C4.41347 13.896 4.80018 14.4748 5.28769 14.9623C5.7752 15.4498 6.35395 15.8365 6.99091 16.1004C7.62787 16.3642 8.31056 16.5 9 16.5C9.68944 16.5 10.3721 16.3642 11.0091 16.1004C11.646 15.8365 12.2248 15.4498 12.7123 14.9623C13.1998 14.4748 13.5865 13.896 13.8504 13.2591C14.1142 12.6221 14.25 11.9394 14.25 11.25Z",
    stroke: "#EB5757",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M12.375 6.375V5.625C12.375 4.72989 12.0194 3.87145 11.3865 3.23851C10.7536 2.60558 9.89511 2.25 9 2.25C8.10489 2.25 7.24645 2.60558 6.61351 3.23851C5.98058 3.87145 5.625 4.72989 5.625 5.625V6.375",
    stroke: "#EB5757",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M14.25 10.5H16.5M3.75 10.5H1.5M10.875 2.625L12.75 1.5M7.125 2.625L5.25 1.5M15.375 15L13.875 14.4M15.375 6L13.875 6.6M2.625 15L4.125 14.4M2.625 6L4.125 6.6M9 16.125V11.25",
    stroke: "#EB5757",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcTaskBug);
export default __webpack_public_path__ + "static/media/ic_task_bug.67e5a5bd85af19fe0aa365b278c9e850.svg";
export { ForwardRef as ReactComponent };